import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import { Loading } from "../../Loader";
import { Modal } from "../../Modal";
import toastMessage from "../../../utils/toastMessage";
import api from "../../../utils/api";
import moment from "moment";
import { capitalizeFirstChar } from "../../Requests/RequestDashboard";
import ReusableDashboard from "../../Dashboard/ReusableDashboard";
import { Table } from "../../Table";
import exportPDF from "../../../utils/exportPDF";
import { generateCSVData } from "../../../utils/formatDataCSV";
import { downloadCSV } from "../../../utils/csvDownloader";
import { defaultChartColors } from "../../Dashboard/DashboardChart";

class DonorDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.csvDownloadRef = React.createRef();
  }

  state = {
    isLoading: false,
    isLoading2: false,
    categoryData: {},
    ageGroupData: {},
    detailedData: {},
    page: 1,
    limit: 10,
    search_text: "",
    searching: "",
    selectedAgeRange: null,
    csvData: [],
    error: {},
    filter: {
      startDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      centers: [],
      centerSites: [],
      status: { value: "pending", label: "Pending" },
    },
  };

  componentDidMount = async () => {
    await this.getData();
  };

  onFilterChange(field, value) {
    const _filters = this.state.filter;
    if (field === "date-range") {
      _filters.startDate = value.startDate;
      _filters.endDate = value.endDate;
    } else {
      _filters[field] = value;
    }

    this.setState({
      filter: { ..._filters },
    });
  }

  getData = async () => {
    this.setState({
      isLoading: false,
      categoryDataLoading: true,
      ageGroupDataLoading: true,
      preDonationAssessmentLoading: true,
    });

    const startDate =
      this.state.filter?.startDate ||
      moment().subtract(1, "months").format("YYYY-MM-DD");
    const endDate = this.state.filter?.endDate || moment().format("YYYY-MM-DD");
    const centers = (this.state.filter?.centers || []).map(
      ({ value }) => value
    );
    const centerSites = (this.state.filter?.centerSites || []).map(
      ({ value }) => value
    );

    const baseOptions = {
      method: "GET",
      params: { startDate, endDate, centers, centerSites },
    };

    const requestId = Date.now();
    this.latestGetDataRequestId = requestId;

    const categoryReq = api({ ...baseOptions, url: `/donor/donors-categories` })
      .then(({ data }) => {
        if (this.latestGetDataRequestId !== requestId) return;
        this.setState({
          categoryData: data || {},
          categoryDataLoading: false,
        });
      })
      .catch((error) => {
        if (this.latestGetDataRequestId !== requestId) return;
        console.error("donors-categories error", error);
        toastMessage("error", error);
        this.setState({ categoryDataLoading: false });
      });

    const ageRangesReq = api({
      ...baseOptions,
      url: `/donor/donor-age-ranges-counts`,
    })
      .then(({ data }) => {
        if (this.latestGetDataRequestId !== requestId) return;
        this.setState({
          ageGroupData: data || {},
          ageGroupDataLoading: false,
        });
      })
      .catch((error) => {
        if (this.latestGetDataRequestId !== requestId) return;
        console.error("donor-age-ranges-counts error", error);
        toastMessage("error", error);
        this.setState({ ageGroupDataLoading: false });
      });

    const assessmentReq = api({
      ...baseOptions,
      url: `/preDonationAssessment/stats`,
    })
      .then(({ data }) => {
        if (this.latestGetDataRequestId !== requestId) return;
        this.setState({
          preDonationAssessment: data || {},
          preDonationAssessmentLoading: false,
        });
      })
      .catch((error) => {
        if (this.latestGetDataRequestId !== requestId) return;
        console.error("preDonationAssessment/stats error", error);
        toastMessage("error", error);
        this.setState({ preDonationAssessmentLoading: false });
      });

    try {
      await Promise.allSettled([categoryReq, ageRangesReq, assessmentReq]);
    } finally {
      if (this.latestGetDataRequestId === requestId) {
        this.setState({ isLoading: false });
      }
    }
  };

  getDonationByAgeRange = async (ageRange, search = {}) => {
    try {
      this.setState({ isLoading2: true });

      const startDate =
        this.state.filter?.startDate ||
        moment().subtract(1, "months").format("YYYY-MM-DD");
      const endDate =
        this.state.filter?.endDate || moment().format("YYYY-MM-DD");
      const centers = (this.state.filter?.centers || []).map(
        ({ value }) => value
      );
      const centerSites = (this.state.filter?.centerSites || []).map(
        ({ value }) => value
      );

      const { page, limit } = this.state;

      const options = {
        method: "GET",
        url: `/donor/donors-list-by-age-range`,
        params: {
          ageRange,
          startDate,
          endDate,
          centers,
          centerSites,
          page,
          limit,
          ...search,
        },
      };

      const { data } = await api(options);

      this.setState({ detailedData: data?.data || {} });
      this.setState({ isLoading2: false });
    } catch (error) {
      this.setState({ isLoading2: false });
      console.error("error", error);
      toastMessage("error", error);
    }
  };

  getDonationByAssessment = async (searchKey, value, search = {}) => {
    try {
      this.setState({ isLoading2: true });

      const startDate =
        this.state.filter?.startDate ||
        moment().subtract(1, "months").format("YYYY-MM-DD");
      const endDate =
        this.state.filter?.endDate || moment().format("YYYY-MM-DD");
      const centers = (this.state.filter?.centers || []).map(
        ({ value }) => value
      );
      const centerSites = (this.state.filter?.centerSites || []).map(
        ({ value }) => value
      );

      const { page, limit } = this.state;

      const options = {
        method: "GET",
        url:
          searchKey !== "regularityCategory"
            ? `/preDonationAssessment/donors-assessment-list-by-categories`
            : `/donor/donor-list-by-category`,
        params: {
          [searchKey === "regularityCategory" ? "category" : searchKey]: value,
          startDate,
          endDate,
          centers,
          centerSites,
          page,
          limit,
          ...search,
        },
      };

      const { data } = await api(options);

      this.setState({ detailedData: data?.data || {} });
      this.setState({ isLoading2: false });
    } catch (error) {
      this.setState({ isLoading2: false });
      console.error("error", error);
      toastMessage("error", error);
    }
  };

  getDonationByAgeRangeForExport = async (ageRange, search = {}) => {
    try {
      const startDate =
        this.state.filter?.startDate ||
        moment().subtract(1, "months").format("YYYY-MM-DD");
      const endDate =
        this.state.filter?.endDate || moment().format("YYYY-MM-DD");
      const centers = (this.state.filter?.centers || []).map(
        ({ value }) => value
      );
      const centerSites = (this.state.filter?.centerSites || []).map(
        ({ value }) => value
      );

      // const { page, limit } = this.state;

      const options = {
        method: "GET",
        url: `/donor/donors-list-by-age-range`,
        params: {
          ageRange,
          startDate,
          endDate,
          centers,
          centerSites,
          page: 1,
          limit: 100000,
          ...search,
        },
      };

      const { data } = await api(options);

      return data?.data;
    } catch (error) {
      console.error("error", error);
      toastMessage("error", error);
      return [];
    }
  };

  getDonationByAssessmentForExport = async (searchKey, value, search = {}) => {
    try {
      const startDate =
        this.state.filter?.startDate ||
        moment().subtract(1, "months").format("YYYY-MM-DD");
      const endDate =
        this.state.filter?.endDate || moment().format("YYYY-MM-DD");
      const centers = (this.state.filter?.centers || []).map(
        ({ value }) => value
      );
      const centerSites = (this.state.filter?.centerSites || []).map(
        ({ value }) => value
      );

      const options = {
        method: "GET",
        url:
          searchKey !== "regularityCategory"
            ? `/preDonationAssessment/donors-assessment-list-by-categories`
            : `/donor/donor-list-by-category`,
        params: {
          [searchKey === "regularityCategory" ? "category" : searchKey]: value,
          startDate,
          endDate,
          centers,
          centerSites,
          page: 1,
          limit: 100000,
          ...search,
        },
      };

      const { data } = await api(options);

      return data?.data;
    } catch (error) {
      console.error("error", error);
      toastMessage("error", error);
      return [];
    }
  };

  handleShowModal(modal, modalType, value) {
    const selectionKey =
      modalType === "ageRange"
        ? "selectedAgeRange"
        : modalType === "regularityCategory"
        ? "regularityCategory"
        : modalType === "assessmentCategory"
        ? "assessmentCategory"
        : null;

    this.setState({
      [modal]: true,
      [selectionKey]: value,
      modalType,
    });
  }

  handleCloseModal() {
    this.setState({
      selectedAgeRange: null,
      regularityCategory: null,
      assessmentCategory: null,
      showModal: false,
    });
  }

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleRemoteSearch = async (modalType, search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));
    if (modalType === "ageRange") {
      await this.getDonationByAgeRange(this.state.selectedAgeRange, {
        q: search || search !== "" ? search : undefined,
      });
    } else {
      await this.getDonationByAssessment(
        modalType,
        this.state.assessmentCategory || this.state.regularityCategory,
        {
          q: search || search !== "" ? search : undefined,
        }
      );
    }

    this.setState({
      searching: false,
    });
  };

  returnTableHeaders(modalType = "ageRange") {
    let headers = [];

    if (modalType === "ageRange") {
      headers = [
        {
          title: language[this.props.defaultLanguage].firstName,
          key: "firstName",
          styles: {
            textTransform: "uppercase",
          },
        },
        {
          title: language[this.props.defaultLanguage].lastName,
          key: "lastName",
          styles: {
            textTransform: "uppercase",
          },
        },
        {
          title: language[this.props.defaultLanguage].nationality,
          key: "gender",
        },
        {
          title: language[this.props.defaultLanguage].age,
          key: "age",
        },
        {
          title: language[this.props.defaultLanguage].center,
          key: "center.name",
        },
        {
          title: language[this.props.defaultLanguage].center_site,
          key: "centerSite.name",
        },
        {
          title: "Created At",
          key: "createdAt",
          isMoment: true,
          formatTime: "lll",
        },
      ];
    } else if (modalType === "regularityCategory") {
      headers = [
        {
          title: language[this.props.defaultLanguage].donor_number,
          key: "donorNumber",
        },
        {
          title: language[this.props.defaultLanguage].firstName,
          key: "firstName",
          styles: {
            textTransform: "uppercase",
          },
        },
        {
          title: language[this.props.defaultLanguage].lastName,
          key: "lastName",
          styles: {
            textTransform: "uppercase",
          },
        },
        {
          title: language[this.props.defaultLanguage].gender,
          key: "gender",
          styles: {
            textTransform: "uppercase",
          },
        },
        {
          title: language[this.props.defaultLanguage].nationality,
          key: "nationality",
        },
        {
          title: language[this.props.defaultLanguage].phone_number,
          key: "phoneNumber",
        },
        {
          title: language[this.props.defaultLanguage].blood_group,
          key: "bloodGroup",
        },
        {
          title: language[this.props.defaultLanguage].category,
          key: "category",
          styles: {
            textTransform: "uppercase",
          },
        },
        {
          title: language[this.props.defaultLanguage].recent_donations,
          key: "recentDonations",
        },
        {
          title: language[this.props.defaultLanguage].total_donations,
          key: "totalDonations",
        },
        {
          title: language[this.props.defaultLanguage].date_of_first_donation,
          key: "firstDonation",
          isMoment: true,
          formatTime: "lll",
        },
        {
          title: language[this.props.defaultLanguage].date_of_last_donation,
          key: "lastDonation",
          isMoment: true,
          formatTime: "lll",
        },
      ];
    } else {
      headers = [
        {
          title: language[this.props.defaultLanguage].firstName,
          key: "donor.firstName",
          styles: {
            textTransform: "uppercase",
          },
        },
        {
          title: language[this.props.defaultLanguage].lastName,
          key: "donor.lastName",
          styles: {
            textTransform: "uppercase",
          },
        },
        {
          title: language[this.props.defaultLanguage].nationality,
          key: "donor.nationality",
        },
        {
          title: language[this.props.defaultLanguage].email,
          key: "donor.email",
        },
        {
          title: language[this.props.defaultLanguage].blood_group,
          key: "donor.bloodGroup",
        },
        {
          title: language[this.props.defaultLanguage].status,
          key: "status",
        },
        {
          title: "Created At",
          key: "createdAt",
          isMoment: true,
          formatTime: "lll",
        },
      ];
    }

    return headers;
  }

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        if (this.state.modalType === "ageRange") {
          this.getDonationByAgeRange(this.state.selectedAgeRange);
        } else {
          this.getDonationByAssessment(
            this.state.assessmentCategory || this.state.regularityCategory
          );
        }
      }
    );
  }

  downloadExcel = async () => {
    try {
      let data = [];
      if (this.state.modalType === "ageRange") {
        data = await this.getDonationByAgeRangeForExport(
          this.state.selectedAgeRange
        );
      } else {
        data = await this.getDonationByAssessmentForExport(
          this.state.modalType,
          this.state.assessmentCategory || this.state.regularityCategory
        );
      }

      const headers = this.returnTableHeaders(this.state.modalType);

      const csvData = generateCSVData(headers, data?.donors);

      downloadCSV(
        csvData,
        `Donor by ${
          this.state.modalType === "ageRange"
            ? "Age Group"
            : this.state.modalType === "regularityCategory"
            ? "Regularity Group"
            : "Assessment Stats"
        }: ${
          this.state.selectedAgeRange ||
          this.state.assessmentCategory ||
          this.state.regularityCategory
        }`
      );
    } catch (error) {
      console.error(error);
    }
  };

  downloadPDF = async () => {
    const headers = this.returnTableHeaders(this.state.modalType);

    let data = [];
    if (this.state.modalType === "ageRange") {
      data = await this.getDonationByAgeRangeForExport(
        this.state.selectedAgeRange
      );
    } else {
      data = await this.getDonationByAssessmentForExport(
        this.state.modalType,
        this.state.assessmentCategory || this.state.regularityCategory
      );
    }

    exportPDF(
      `Donor by ${
        this.state.modalType === "ageRange"
          ? "Age Group"
          : this.state.modalType === "regularityCategory"
          ? "Regularity Group"
          : "Assessment Stats"
      }: ${this.state.selectedAgeRange}`,
      headers,
      data?.donors || []
    );
  };

  render() {
    return (
      <>
        <ReusableDashboard
          loading={this.state.isLoading}
          filtersConfig={{
            hasCenters: true,
            hasSites: true,
            initialValues: this.state.filter,
            onFilterChange: (field, value) => this.onFilterChange(field, value),
          }}
          // filters={this.state.filter}
          onFind={() => this.getData()}
          cardGroups={[
            {
              title: "Donors By Regularity Group",
              color: defaultChartColors[0],
              col: 3,
              isLoading: this.state.categoryDataLoading,
              items: [
                {
                  title: "Total",
                  count: this.state.categoryData?.total || 0,
                },
                ...Object.keys(this.state.categoryData || {})
                  .filter((item) => item !== "total" && item !== "blocked")
                  .map((key) => {
                    const canPress = (this.state.categoryData[key] || 0) > 0;
                    return {
                      title: capitalizeFirstChar(key),
                      count: this.state.categoryData[key] || 0,
                      onPress:
                        !!canPress &&
                        (() => {
                          this.handleShowModal(
                            "showModal",
                            "regularityCategory",
                            key
                          );
                          this.getDonationByAssessment(
                            "regularityCategory",
                            key
                          );
                        }),
                    };
                  }),
                {
                  title: "Blocked",
                  count: this.state.categoryData?.blocked || 0,
                  onPress:
                    !!this.state.categoryData?.blocked &&
                    (() => {
                      this.handleShowModal(
                        "showModal",
                        "regularityCategory",
                        "blocked"
                      );
                      this.getDonationByAssessment(
                        "regularityCategory",
                        "blocked"
                      );
                    }),
                },
              ],
            },
            {
              title: "Donor Appointment Efficacy: Potential vs. Actual",
              color: defaultChartColors[2],
              col: 3,
              isLoading: this.state.preDonationAssessmentLoading,
              items: [
                {
                  title: "Total",
                  count:
                    this.state.preDonationAssessment?.totalAssessments || 0,
                },
                ...Object.keys(this.state.preDonationAssessment || {})
                  .filter((item) => item !== "totalAssessments")
                  .map((key) => {
                    const canPress =
                      !["conversionRate", "eligibilityRate"].includes(key) &&
                      (this.state.preDonationAssessment[key] || 0) > 0;
                    return {
                      title: capitalizeFirstChar(key),
                      count: this.state.preDonationAssessment[key] || 0,
                      onPress:
                        !!canPress &&
                        (() => {
                          this.handleShowModal(
                            "showModal",
                            "assessmentCategory",
                            key
                          );
                          this.getDonationByAssessment(
                            "assessmentCategory",
                            key
                          );
                        }),
                    };
                  }),
              ],
            },
            {
              title: "Donors By Age Group",
              color: defaultChartColors[1],
              col: 3,
              isLoading: this.state.ageGroupDataLoading,
              items: [
                {
                  title: "Total",
                  count: this.state.ageGroupData?.total || 0,
                },
                ...Object.keys(this.state.ageGroupData || {})
                  .filter((item) => item !== "total")
                  .map((key) => {
                    const canPress = (this.state.ageGroupData[key] || 0) > 0;
                    return {
                      title: capitalizeFirstChar(key),
                      count: this.state.ageGroupData[key] || 0,
                      onPress:
                        !!canPress &&
                        (() => {
                          this.handleShowModal("showModal", "ageRange", key);
                          this.getDonationByAgeRange(key);
                        }),
                    };
                  }),
              ],
            },
          ]}
        />

        <Modal
          show={!!this.state.selectedAgeRange}
          title={`Donor by Age Group: ${this.state.selectedAgeRange}`}
          handleClose={() => this.handleCloseModal()}
          size="lg"
        >
          {!this.state.detailedData || !!this.state.isLoading2 ? (
            <center>
              <Loading />
            </center>
          ) : (
            <div
              className="card-body"
              style={{ maxHeight: "80vh", overflowY: "auto" }}
            >
              <Table
                data={this.state.detailedData?.donors}
                isSearch
                page={this.state.detailedData?.page}
                limit={this.state.detailedData?.limit}
                search_text={this.state.search_text}
                totalPageCount={this.state.detailedData?.totalCount}
                isLoading={this.state.isLoading2}
                handlePagination={this.handlePagination.bind(this)}
                headers={this.returnTableHeaders("ageRange")}
                addSearchButton
                searching={this.state.searching}
                handleSearch={this.handleSearch.bind(this)}
                handlePressSearch={() =>
                  this.handleRemoteSearch("ageRange", this.state.search_text)
                }
                filters={[
                  {
                    type: "export",
                    title: "Export",
                    button_type: "dropdown",
                    icon: "download",
                    options: [
                      {
                        name: "PDF",
                        onPress: this.downloadPDF.bind(this),
                      },
                      {
                        name: "CSV",
                        onPress: this.downloadExcel.bind(this),
                      },
                    ],
                  },
                ]}
              />
            </div>
          )}
        </Modal>

        <Modal
          show={
            !!this.state.assessmentCategory || this.state.regularityCategory
          }
          title={`Donor list: ${
            this.state.assessmentCategory || this.state.regularityCategory
          }`}
          handleClose={() => this.handleCloseModal()}
          size="lg"
        >
          {!this.state.detailedData || !!this.state.isLoading2 ? (
            <center>
              <Loading />
            </center>
          ) : (
            <div
              className="card-body"
              style={{ maxHeight: "80vh", overflowY: "auto" }}
            >
              <Table
                data={this.state.detailedData?.donors}
                isSearch
                page={this.state.detailedData?.page}
                limit={this.state.detailedData?.limit}
                search_text={this.state.search_text}
                totalPageCount={this.state.detailedData?.totalCount}
                isLoading={this.state.isLoading2}
                handlePagination={this.handlePagination.bind(this)}
                headers={this.returnTableHeaders(this.state.modalType)}
                addSearchButton
                searching={this.state.searching}
                handleSearch={this.handleSearch.bind(this)}
                handlePressSearch={() =>
                  this.handleRemoteSearch(
                    this.state.modalType,
                    this.state.search_text
                  )
                }
                filters={[
                  {
                    type: "export",
                    title: "Export",
                    button_type: "dropdown",
                    icon: "download",
                    options: [
                      {
                        name: "PDF",
                        onPress: this.downloadPDF.bind(this),
                      },
                      {
                        name: "CSV",
                        onPress: this.downloadExcel.bind(this),
                      },
                    ],
                  },
                ]}
              />
            </div>
          )}
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(DonorDashboard);
